import { Button, Col, Form, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import {
  setBeneficiaryList,
  setIsShowAdmissionForm,
  setSelectedBeneficiary,
} from '../../../../../../store/actions/newAdmissionAction';
import { useDispatch, useSelector } from 'react-redux';
import { FormInputMobile, FormTextInput } from '../../../../../../shared/components/crmFormElement/FormInput';
import { RootState } from '../../../../../../store';
import {
  getPolicySearchResults, setMemberName, setPayerDropDownVisible, setPolicySearchResults,
  setSelectedPolicyDetail,
} from '../../../../../../store/actions/nhcxAction';
import { centeredNotification, getMobileFormat } from '../../../../../../utils/utility';
import { Payer } from '../../../../../../shared/models/payer.model';
import {
  VALIDATE_MESSAGES } from '../../../../../../shared/constants/commonConstants';
import { isEmpty } from 'lodash';
import { PayerInitialState } from '../../../../../../store/models/payerListModel';
import { ReactComponent as SearchIcon } from '../../../../../../../src/assets/images/svg/Search_Icon.svg';
import { formInputStates } from '../../../../../../shared/constants/crmConstants';
import { handleUserFocus, updateInputStates } from '../../../service/crmUtils';

const PolicySearchRedesign = (props: any): ReactElement | null => {
  const {searchType, onSearchSuccess, onSearchError, resetMultipleSteps} = props;
  const dispatch = useDispatch();
  const [showPanel, setShowPanel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [policySearchForm] = Form.useForm();
  const [disableSearch, setDisableSearch] = useState<boolean>(true);
  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const { selectedPatientDetail } = useSelector((state: RootState): any => state.hospital);
  const { payer } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const [inputStates, setInputStates] = useState(formInputStates.PolicyRedesignForm);

  useEffect((): any => {
    if (searchType === 'insurance') {
      dispatch(setPayerDropDownVisible(true));
      setShowPanel(false);
    } else {
      setShowPanel(true);
      dispatch(setPayerDropDownVisible(false));
    }
    dispatch(setPayerDropDownVisible(false));
  }, [searchType]);

  // scroll down on panel render
  useEffect((): void => {
    const shouldScroll = showPanel && !isEmpty(selectedPatientDetail);
    if (shouldScroll) {
      const element = document.querySelector('.policy-search-div-container');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [showPanel]);

  useEffect((): any => {
    if (payer?.id !== 0) {
      dispatch(setIsShowAdmissionForm(true));
    } else {
      dispatch(setIsShowAdmissionForm(false));
    }
  }, [payer]);

  useEffect((): void => {
    if (!isEmpty(selectedPatientDetail)) {
      const patientName = selectedPatientDetail.memberName || selectedPatientDetail?.patientDetails?.patientName;
      const healthId = selectedPatientDetail?.patientDetails?.abhaId;
      const mobileNo = getMobileFormat(selectedPatientDetail?.mobile || selectedPatientDetail?.patientDetails?.mobileNumber);
      const policySearchDetails = {
        patientName,
        healthId: searchType === 'abha' ? healthId : undefined,
        mobileNo: searchType === 'mobile' ? mobileNo : undefined,
      };
      policySearchForm.setFieldsValue(policySearchDetails);
      updateInputStates(policySearchDetails, setInputStates);
    }
  }, [selectedPatientDetail, searchType]);

  const onSearch = (formVal: any): any => {
    updateInputStates(formVal, setInputStates, '.policy-search-row input',
      { resetFocus: true, blurDomInputs: true });
    validateFields();
    resetPolicySearch();
    const formattedMobileNo = formVal?.mobileNo?.replace('+91', '')?.replace(/ /g, '');
    const payload = {
      ...formVal,
      'patientName': policySearchForm.getFieldValue(['patientName']),
      'mobileNo': formattedMobileNo,
      'isNHCXEnabledProvider': true,
      'isDirectFlow': false,
    };
    const patientName = policySearchForm.getFieldValue(['patientName']);
    dispatch(setMemberName(patientName));
    policySearchForm.validateFields().then((): any => {
      dispatch(getPolicySearchResults(payload, onSuccess, onError));
      setLoading(true);

    }).catch((): any => {
      centeredNotification('Please enter the fields to Proceed');
    });
  };

  const onSuccess = (policyDetails: any): any => {
    setLoading(false);
    dispatch(setSelectedPolicyDetail([]));
    policyDetails?.map((ele: any): any => {
      const policyPayerName = configuredPayers.filter((payerValue: any): any => payerValue?.key === String(ele?.payerId));
      if (policyPayerName?.[0]?.name !== undefined) {
        ele.payerName = policyPayerName?.[0]?.name;
        ele.disabled = false;
        ele.nhcxEnabledRoutingApi = policyPayerName?.[0]?.nhcxEnabledRoutingApi;
        ele.nhcxEnabledPayerForProvider = policyPayerName?.[0]?.isNHCXEnabledPayerProvider;
      } else {
        ele.disabled = true;
      }
    });
    dispatch(setPolicySearchResults(policyDetails));
    onSearchSuccess();
    dispatch(setPayerDropDownVisible(true));
  };

  const onError = (): void => {
    setLoading(false);
    onSearchError();
    dispatch(setPayerDropDownVisible(true));
  };

  const validateFields = (): any => {
    setTimeout((): any => {
      policySearchForm
        ?.validateFields()
        .then((): any => {
          setDisableSearch(false);
        })
        .catch((error: any): any => {
          const { errorFields } = error;
          if (errorFields?.length > 0) {
            setDisableSearch(true);
          }
        });
    }, 200);
  };

  const resetPolicySearch = (): void => {
    resetMultipleSteps(['policyCard', 'memberSearch', 'memberOrPolicy', 'documentsAttached', 'claimReviewed', 'memberCard']);
    dispatch(setSelectedPolicyDetail(null));
    dispatch(setPolicySearchResults([]));
    dispatch(setBeneficiaryList([]));
    dispatch(setSelectedBeneficiary(null));
    dispatch(setIsShowAdmissionForm(false));
  };

  return (
    <>
      {showPanel &&
        <>
          <div className="policy-search-div-container">
            <Form
              form={policySearchForm}
              layout="vertical"
              onFinish={onSearch}
              validateMessages={VALIDATE_MESSAGES}
              onValuesChange={resetPolicySearch}
              noValidate={true}
            >
              <Row gutter={24} className="policy-search-row search-align-items">
                <Col md={13} className="policy-holder pd-19">
                  <FormTextInput detail={{
                    key: 'patientName',
                    hideLabel: true,
                    isName: true,
                    label: 'Beneficiary Name',
                    placeholder: inputStates?.patientName?.isFocused ? '' : 'Enter Beneficiary Name',
                    rules: [{ required: true, message: `Name is required!`}],
                    className: 'HISSearchUI',
                    onFocus: (e: any): void => handleUserFocus('patientName', setInputStates, true, !!e.target.value),
                    onBlur: (e: any): void => handleUserFocus('patientName', setInputStates, false, !!e.target.value),
                    floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName.hasValue,
                    searchType: 'NHCX',
                    fieldInFocus: inputStates?.patientName?.isFocused,
                    disabled: loading,
                  }}
                  />
                </Col>
                {searchType === 'mobile' &&
                  <Col md={9} className="policy-search-type">
                    <FormInputMobile detail={{
                      key: 'mobileNo',
                      hideLabel: true,
                      isName: true,
                      label: 'Mobile No.',
                      placeholder: inputStates?.mobileNo?.isFocused ? '' : 'Enter Mobile No.',
                      onFocus: (e: any): void => handleUserFocus('mobileNo', setInputStates, true, !!e.target.value),
                      onBlur: (e: any): void => handleUserFocus('mobileNo', setInputStates, false, !!e.target.value),
                      floatLabel: inputStates?.mobileNo?.isFocused || inputStates?.mobileNo?.hasValue,
                      rules: [{ required: true, message: 'Mobile No. is required!'}],
                      searchType: 'NHCX',
                      fieldInFocus: inputStates?.mobileNo?.isFocused,
                      disabled: loading,
                      className: 'HISSearchUI',
                    }}
                    />
                  </Col>
                }
                {searchType === 'abha' &&
                  <Col md={9} className="policy-search-type">
                    <FormTextInput detail={{
                      key: 'healthId',
                      hideLabel: true,
                      isName: true,
                      label: 'ABHA No.',
                      placeholder:  inputStates.healthId.isFocused ? '' : 'Enter Your ABHA Number',
                      className: 'HISSearchUI',
                      // making required false as we are already adding it in the rules due to which the 2 validation errors pop up
                      required: false,
                      onFocus: (e: any): void => handleUserFocus('healthId', setInputStates, true, !!e.target.value),
                      onBlur: (e: any): void => handleUserFocus('healthId', setInputStates, false, !!e.target.value),
                      floatLabel: inputStates?.healthId?.isFocused || inputStates?.healthId?.hasValue,
                      rules: [{ required: true, message: 'ABHA Number is required!'}],
                      searchType: 'NHCX',
                      fieldInFocus: inputStates?.healthId?.isFocused,
                      disabled: loading,
                    }}
                    />
                  </Col>
                }
                <Col md={2} className="policy-search-button">
                  <Button
                    type= {disableSearch ? undefined : 'primary'}
                    loading={loading}
                    htmlType="submit"
                    className={`NA-his-next-button benef-submit-btn`}
                    icon={<SearchIcon className="his-policy-search-icon"/>}
                  />
                </Col>
              </Row>
            </Form>
            <></>
          </div>
        </>
      }
    </>
  );
};
export default PolicySearchRedesign;
